var urlUtils = require('@173js/url')

module.exports = function requireLogin(callback) {

  return function() {
    var Passport = window.Passport || {}
      , args = arguments

    if (Passport && Passport.defaultOption) {
      Passport.defaultOption.mobileBindOn=false
    }

    if(!Passport.isLoggedIn()) {
      window.location.href =
        urlUtils.addParam(
          'https://passport.17173.com/wap', { from: window.location.href }
        )

      return
    }

    callback.apply(this, args)
  }
}
